import PropTypes from "prop-types"

export const propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}

export const textDefault = {
  variant: "text",
  color: "default",
  onClick: undefined,
  disabled: false
}

export const containedPrimary = {
  variant: "contained",
  color: "primary",
  onClick: undefined,
  disabled: false
}

export const containedSecondary = {
  variant: "contained",
  color: "secondary",
  onClick: undefined,
  disabled: false
}

export const outlinedDefault = {
  variant: "outlined",
  color: "default",
  onClick: undefined,
  disabled: false
}

export const outlinedPrimary = {
  variant: "outlined",
  color: "primary",
  onClick: undefined,
  disabled: false
}

export const outlinedSecondary = {
  variant: "outlined",
  color: "secondary",
  onClick: undefined,
  disabled: false
}
